// -------------------------
// 🌎 GLOBAL LISTICLE WATCHER
// -------------------------

// Always start — will self-skip if nothing to do
startListicleWatcher();

function startListicleWatcher() {
  console.log("🧩 Listicle watcher initialized.");
  document.addEventListener("kaching:cart:updated", listicleSyncGifts);
  document.addEventListener("rebuy:cart:update", listicleSyncGifts);
  setInterval(listicleSyncGifts, 3000);
  listicleSyncGifts();
}

// --- 🩶 SYNC GIFTS ---
async function listicleSyncGifts() {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) return;
    const cart = await res.json();

    const mainItems = cart.items.filter(
      i => i.properties && i.properties._listicle === "true" && !i.properties._gift
    );
    const giftItems = cart.items.filter(
      i => i.properties && i.properties._gift && i.properties._from === "listicle"
    );

    // if nothing listicle-related, just enforce checkout once and stop
    if (mainItems.length === 0 && giftItems.length === 0) {
      await listicleEnforceCheckout(cart);
      return;
    }

    // 🔁 keep gift qty in sync with their parent
    for (const main of mainItems) {
      const related = giftItems.filter(g => g.properties._parent == main.variant_id);
      for (const gift of related) {
        if (gift.quantity !== main.quantity) {
          await safeCartChange(gift.key, main.quantity);
        }
      }
    }

    // ❌ remove orphaned gifts (no parent in cart)
    const validParentIds = mainItems.map(m => String(m.variant_id));
    const orphaned = giftItems.filter(
      g => !validParentIds.includes(String(g.properties._parent))
    );

    if (orphaned.length) {
      console.log(`🧹 Removing ${orphaned.length} orphaned gifts...`);
      const updates = {};
      orphaned.forEach(g => (updates[g.key] = 0));
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });
    }

    // 🚫 always enforce checkout rules afterward
    await listicleEnforceCheckout(cart);

  } catch (err) {
    console.error("❌ listicleSyncGifts failed", err);
  }
}

async function safeCartChange(key, qty) {
  try {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  } catch (err) {
    console.warn("⚠️ Safe cart change failed", err);
  }
}

// --- 🚫 CHECKOUT ENFORCER ---
async function listicleEnforceCheckout(existingCart = null) {
  try {
    const cart = existingCart || (await fetch("/cart.js").then(r => r.json()));
    const total = cart.total_price / 100;
    const hasPaid = cart.items.some(i => !i.properties?._gift);
    const block = total <= 0 || !hasPaid;

    const buttons = document.querySelectorAll(
      '[name="checkout"], .cart__checkout, .cart__checkout-button, .rebuy-cart__checkout-button, .kaching-cart__checkout-btn'
    );

    document.querySelectorAll(".checkout-warning").forEach(el => el.remove());

    buttons.forEach(btn => {
      btn.disabled = block;
      btn.style.pointerEvents = block ? "none" : "auto";
      btn.style.opacity = block ? "0.5" : "1";

      if (block) {
        const msg = document.createElement("div");
        msg.className = "checkout-warning";
        msg.textContent = "⚠️ Checkout disabled — please add a paid product to continue.";
        msg.style.color = "#b91c1c";
        msg.style.fontSize = "14px";
        msg.style.textAlign = "center";
        msg.style.marginTop = "8px";
        msg.style.fontWeight = "500";
        btn.insertAdjacentElement("afterend", msg);
      }
    });

    if (block && window.location.pathname.includes("/checkout")) {
      alert("You can’t checkout with only free gifts. Please add a paid product first.");
      window.location.href = "/cart";
    }

  } catch (err) {
    console.warn("⚠️ Checkout enforcement failed", err);
  }
}

// --- wake watcher manually after add ---
window.listicleGiftWatcher = startListicleWatcher;
